module.exports = __webpack_public_path__ + "static/media/mcmahon-associates.07732f4e.png";